import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import FormField from "../../dynamicFormBuilder/FormField";
import { DetailPrimaryLayout } from "./Layout";
import DetailLocationGrid from "./DetailLocationGrid";
import { STATUS_COMMITTED } from "../itemManagement/transactionsTab/codeLists";
import "./detailPrimary.css";

// Details tab -> "Primary" sub-tab for the IM Transaction Entry form (Delphi uIMD0019 Details/Primary).
// Two columns: left = selected line's Item/Lot info (UOM + Net Available, read-only); right = that line's
// location breakdown grid. The selected line is passed in as formFields.
function DetailPrimaryTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => DetailPrimaryLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        if (props.handleFieldChange) props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    const handleFormLoad = useCallback(() => {}, []);

    return (
        <div className="row">
            <div className="col-md-5 im-detail-primary">
                <FormField
                    currrentUser={currentUser}
                    layoutId="0019d019-5d78-4f9a-e4fb-0019eeff0004"
                    layoutName="IMTransactionEntryDetailPrimaryForm"
                    defaultFormSchema={finalLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={props.formRefs}
                    onFormLoad={handleFormLoad}
                />
            </div>
            <div className="col-md-7" style={{ height: 260 }}>
                <DetailLocationGrid
                    detailRowId={props.formFields?.rowid}
                    transactionType={props.transactionType}
                    disabled={props.status === STATUS_COMMITTED}
                    onChanged={props.onLocationsChanged}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(DetailPrimaryTab);
